import { Loader } from "@googlemaps/js-api-loader"

export default class MapVictoria {

    /**
     * Initializes the Victoria map module.
     * Pass your Google Maps Javascript API key
     */
    static init(apiKey) {
        return new MapVictoria(apiKey);
    }

    constructor(apiKey) {
        const self = this;

        if (!window.CookieConsent) {
            console.error('Cookie Byte is not implemented or not initialized. Please initialize before initialization of Map Victoria');
            return;
        }

        if (window.CookieConsent.hasConsent('googlemaps'))
            self.loadMaps(apiKey);
        else
            window.CookieConsent.registerCallback('googlemaps', function() {
                self.loadMaps(apiKey);
            }, this);
    }

    loadMaps(apiKey) {
        const loader = new Loader({
            apiKey: apiKey,
            version: "weekly",
        });

        loader.load().then(() => {
            let maps = document.querySelectorAll('.map-victoria .map');
            maps.forEach((map) => {
                this.setupMap(map);
            });
        });
    }

    /**
     * Inits a single map victoria instance and displays the requested pins
     * @param {HTMLElement} mapElement 
     * @returns void
     */
    setupMap(mapElement) {
        if (!mapElement) return;

        let pinsJson = mapElement.getAttribute('pins');
        let pins = pinsJson ? JSON.parse(pinsJson) : [];

        let centerLat = Number(mapElement.getAttribute('data-center-lat'));
        let centerLng = Number(mapElement.getAttribute('data-center-lng'));
        let zoomLevel = Number(mapElement.getAttribute('data-zoom'));

        if (window.innerWidth < 500)
            zoomLevel -= 1;

        let mapOptions = {
            zoom: zoomLevel,
            center: new google.maps.LatLng(centerLat, centerLng),
            streetViewControl: false,
            overviewMapControl: false,
            mapTypeControl: false,
            /* styles: GoogleMapStyling */
        };

        let map = new google.maps.Map(mapElement, mapOptions);

        pins.forEach(function (pin) {
            this.addPin(map, pin);
        }, this);
    }

    addPin(map, pin) {
        new google.maps.Marker({
            position: { lat: pin.latitude, lng: pin.longitude },
            map: map,
            icon: {
                url: '/svg/pin.svg',
                scaledSize: new google.maps.Size(35, 35),
            },
            cursor: 'grab'
        });
    }
}